import { Component, inject, OnInit } from '@angular/core';
import { AppStateService, ActivePage } from '../../../shared/services/app-state.service';
import { takeUntil } from 'rxjs/operators';
import { SubsectionService } from '../../../shared/services/subsection.service';
import { Subject } from 'rxjs';
import { DriveTreeUiService } from '../../../shared/drive/drive-tree-ui.service';

@Component({
  selector: 'top-nav-treeview-btn',
  templateUrl: './top-nav-treeview-btn.component.html',
  styleUrl: './top-nav-treeview-btn.component.scss',
  standalone: false,
})
export class TopNavTreeviewBtnComponent implements OnInit {
  private readonly appState = inject(AppStateService);
  private readonly subsectionService = inject(SubsectionService);
  private readonly driveTreeUi = inject(DriveTreeUiService);
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  explorerCollapsed: boolean = false;

  /**
   * Pressed state. On a drive surface it mirrors the explorer's own tree state
   * (drawer open below 992px, column shown from it); elsewhere the legacy subsection
   * explorer's `explorerCollapsed`.
   */
  get treeExpanded(): boolean {
    return this.driveTreeUi.active() ? this.driveTreeUi.treeExpanded() : !this.explorerCollapsed;
  }

  get isSubsectionPage(): boolean {
    return this.appState.getActivePage() === ActivePage.ProjectSubsection;
  }

  /** Also shown on My Own Space — a drive surface with the same tree-toggle behaviour, just no project. */
  get isMySpacePage(): boolean {
    return this.appState.getActivePage() === ActivePage.MySpace;
  }

  ngOnInit(): void {
    this.subsectionService.uiState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (state) => {
        this.explorerCollapsed = state?.explorerCollapsed || false;
      },
    });
  }

  public toggleTreeview(): void {
    // A drive surface toggles its own tree, width-aware (drive-fe ADR-0044): the left
    // drawer on phones and tablets, the column ↔ rail on desktop.
    if (this.driveTreeUi.active()) {
      this.driveTreeUi.toggleTree();
      return;
    }
    this.subsectionService.updateUIState({ explorerCollapsed: !this.explorerCollapsed });
  }
}
